import toError from '@sail/observability/dist/helpers/toError/toError';
import {IntlError, IntlLocaleDataError} from 'src/internal/errors';

import type {IReports} from '@sail/observability';

export default function handleGlobalizeError(
  maybeError: unknown,
  reports: IReports,
): never {
  const errorMessage = toError(maybeError);
  const errorKey = errorMessage.message.match(/^[^:]+/)?.[0];

  let resultingError: Error;

  switch (errorKey) {
    case 'E_INVALID_CLDR':
    case 'E_MISSING_CLDR':
      resultingError = new IntlLocaleDataError(errorMessage.message);
      break;
    default:
      resultingError = new IntlError(errorMessage.message);
  }

  reports.error(resultingError, {project: 'sail_core'});

  throw resultingError;
}
